import { useState, memo } from 'react';
import { DEFAULT_AVATAR, getInitials } from '@/components/ui';

interface ChatAvatarProps {
  src?: string | null;
  name: string;
  /** Tailwind size classes, e.g. "h-10 w-10" */
  size?: string;
  /** Border color class, e.g. "border-white/20" */
  borderColor?: string;
  /** @deprecated No longer used — kept for API compat */
  fallbackClass?: string;
  /** @deprecated No longer used — kept for API compat */
  textSize?: string;
  className?: string;
}

export const ChatAvatar = memo(function ChatAvatar({
  src,
  name,
  size = 'h-10 w-10',
  borderColor = 'border-white/20',
  className = '',
}: ChatAvatarProps) {
  const [imgError, setImgError] = useState(false);
  const isDefault = !src || imgError;

  if (isDefault) {
    return (
      <div
        className={`${size} rounded-full border-2 border-gray-200 relative overflow-hidden bg-white ${className}`}
      >
        <img src={DEFAULT_AVATAR} alt={name} className="absolute inset-0 w-full h-full object-contain opacity-20 p-[18%]" />
        <span className="absolute inset-0 flex items-center justify-center font-bold text-sky-700 text-xs">
          {getInitials(name)}
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      onError={() => setImgError(true)}
      className={`${size} rounded-full border ${borderColor} object-cover ${className}`}
    />
  );
});
